export default new class Languages {
    constructor() {
        this.languages = 'languages';
        this.languagesButton = 'languages__button';
        this.languagesOpen = 'languages_open';
        this.handler();
        this.hide()
    }

    handler() {
        $(document).on('click', `.${this.languagesButton}`, ({currentTarget}) => {
            $(currentTarget).parent().toggleClass(`${this.languagesOpen}`)
        });
    }

    hide() {
        $(document).on('click', ({ target }) => {
            if ($(target).closest(`.${this.languagesOpen}`).length === 0) {
                $(`.${this.languages}`).removeClass(`${this.languagesOpen}`);
            }
        });
    }
}();
